/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  getDeactivated() {
    return axios.get(`${this.url}?filter=deactivated`);
  }

  reactivate(agentId) {
    return axios.put(`${this.url}/${agentId}/reactivate`);
  }

  disconnectPhone(agentId) {
    return axios.post(`${this.url}/${agentId}/phone_status/disconnect`);
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }
}

export default new Agents();
